import { FetchJson } from './Fetch';

const communicationAPI = {
    getProgress:(classId) => FetchJson.get( `/admin-class/${classId}/in-progress`),
    getMyInfo:() => FetchJson.get( `/auth`),
    getCategory:(data:object) => FetchJson.get("/common/category", data),
    getJobList:(data:object) => FetchJson.get(`/common/jobList`, data),
    getHomeworkList:(data:object) => FetchJson.get(`/homework`, data),
    userLogout:() => FetchJson.get( `/auth/logout`),    
    postCategory:(data:object) => FetchJson.post(`/common/category`, data),
    postVideoMetadata:(data:object) => FetchJson.post(`/jw-player/token`, data),
    patchVideoMetadata:(jwPlayerId:string, data:object) => FetchJson.patch(`/jw-player/token/${jwPlayerId}`, data),
    postSignInData:(data) => FetchJson.post(`/auth/signin`,data),    
    putHomework:(id,data) => FetchJson.put(`/homework/${id}/feedback`, data),   
    putReview: (id,data) => FetchJson.put(`/reviews/${id}`, data),   
    getReview: (data?:object) => FetchJson.get(`/reviews`,data),   
    getReviewById: (id) => FetchJson.get(`/reviews/${id}`),   
    getQnA:(data?:object) => FetchJson.get(`/qna`,data),   
    updateQna:(id:string,data?:object) => FetchJson.put(`/qna/${id}/answer`,data),   
    editQna:(id:string,answerId:string,data?:object) => FetchJson.put(`/qna/${id}/answer/${answerId}`,data),   
    deleteQna:(id:string,answerId:string,data?:object) => FetchJson.delete(`/qna/${id}/answer/${answerId}`,data),   
    getQnAById:(id?:string) => FetchJson.get(`/qna/${id}`),   
}

export { communicationAPI };